"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _ConfirmationModal = _interopRequireDefault(require("@insided/shared/uikit/Modal/ConfirmationModal"));

var MarkAsNotSpamModal = function MarkAsNotSpamModal(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      onToggleSpam = _ref.onToggleSpam,
      selectedReplyId = _ref.selectedReplyId;
  var bodyText = "The ".concat(selectedReplyId === undefined ? 'topic' : 'reply', " will be visible again in community. If the user was banned, this action will not unban the author automatically, please go to user profile page in control and change user role.");
  return (0, _preact.h)(_ConfirmationModal.default, {
    title: "Mark as not spam?",
    body: bodyText,
    action: (0, _absoluteUrlRuntime.resolveUrl)("Mark as not spam"),
    variant: "brand",
    isOpen: isOpen,
    onClose: onClose,
    handleConfirmation: onToggleSpam
  });
};

var _default = MarkAsNotSpamModal;
exports.default = _default;